export const environment = {
  production: false,
  keycloak: {
    url: 'https://keycloak.rainti.com.br',
    realm: 'registro-garantia-dev',
    clientId: 'web-gestao'
  },
  apiUrl: 'https://gbff-web.dev.rainti.com.br'
};